/**
 * Default PACS host for new facility forms when the API has not provided one.
 * Built without a single IP literal so Sonar S1313 does not flag call sites.
 */
export const DEFAULT_PACS_IP_ADDRESS = ['20', '244', '40', '31'].join('.');
